// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-footer{
    background-color: #f1f3f7!important;
}


.footer-top {

}

.container{
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}

section {
    display: block;
}

footer {
    display: block;
}


.padding-top {
    padding-top: 32px;
}


.border-top-gray {
    border-top: 1px solid #e0e0e0!important;
}

a {
    color: #777;
    text-decoration: none;
    font-size: 0.805rem;
    font-weight: 400;
    line-height: 1.5;
    transition: all .25s ease;
    background-color: transparent;
}

a:-webkit-any-link {
    cursor: pointer;
}
a:hover {
    color: #b16927;
}

h5 {
    display: block;
    font-size: 1.00625rem;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-family: inherit;
    margin-bottom: 0.5rem;
    line-height: 1.2;
}


    .btn-group { position: relative; display: inline-flex; vertical-align: middle;}
    .white {color: #fff;}


    .btn-facebook {background-color: #405D9D; color: #fff;}
    .btn-facebook:hover {color: #fff;}

    .btn-instagram {background-color: #E52D27;color: #fff;}
    .btn-instagram:hover {color: #fff;}

    .btn-youtube {background-color: #C8046C; color: #fff;}
    .btn-youtube:hover {color: #fff;}

    .btn-twitter {background-color: #42AEEC; color: #fff;}
    .btn-twitter:hover {color: #fff;}



.btn {
    font-size: .875rem;
    transition: all .2s ease;
    letter-spacing: .025em;
    text-transform: uppercase;
    font-weight: 600;
    line-height: 1.5;
    padding: 0.625rem 1.25rem;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    border-radius: 50px;
    box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
}

.btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08);
}

.fab{
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-feature-settings: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    font-weight: 400;
    font-family: Font Awesome\\ 5 Brands;
}

.fa-fw {
    text-align: center;
    width: 1.2em;
}

.fas{
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-feature-settings: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    font-family: Font Awesome\\ 5 Free;
    font-weight: 900;
    font-size: 1.00625rem;
    color: inherit;
    margin-right: 0.3125rem;
}

.title{
    font-weight: 600;
}

.display-inline-block{
    display: inline-block!important;
}

.mt-4{
    margin-top: 1.5rem!important; 
}

.h5Lang{
    font-size: 1.00625rem;
    margin-bottom: 0.5rem;
    font-family: inherit;
    line-height: 1.2;
    color: inherit;
    margin-block-start: 1.67em;
    margin-block-end: 1.67em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;

}

.clearfix{
    content: "";
    clear: both;
    display: table; 
}

.footer-bottom{
    padding: 15px 0;
}

.row{
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
}

.col-sm-12{
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
}


p {
    margin-top: 0;
    /* margin-bottom: 1rem; */
    display: block;
    /* margin-block-start: 1em; */
    /* margin-block-end: 1em; */
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

.text-center{
    text-align: center!important;
}

.text-dark{
    color: #343a40!important;
}

.text-gray {
    color: #f1f3f7!important;
    margin-left: 3px;
    margin-right: 3px;
}

.text-dark-50 {
    font-size: .805rem;

}

strong {
    font-weight: bolder;
}
* {
    box-sizing: border-box;
}











.dropdown {
    position: relative;
}

.ml-5 {
    margin-left: 2.5rem!important;
}

.display-inline-block {
    display: inline-block!important;
}

.fa-caret-down::before {
    content: "\\f0d7"; 
}
::before {
    box-sizing: border-box;
}

.flag {
    width: 1.46667rem;
    height: 1.15rem;
    display: inline-block;
    background: no-repeat 50%/100% 100%;
    vertical-align: bottom;
    font-style: normal;
    box-shadow: 0 0 1px 1px rgb(0 0 0 / 10%);
    
}

.ml-2 {
    margin-left: 0.5rem!important;
}

.dropdown-menu.show {
    box-shadow: 0 3px 8px rgb(0 0 0 / 15%);
    border: 1px solid rgba(0,40,100,.12);
    border-radius: 0;
    display: block;
}

.dropdown-menu[x-placement^=top] {
    right: auto;
    bottom: auto;
}

.dropdown-menu {
    z-index: 1000;
    float: left;
    min-width: 10rem;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: .805rem;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
}

.dropdown-item {
    padding: 0.5rem 1.5rem;
    margin: 5px 0;
    display: block;
    width: 100%;
    clear: both;
    font-weight: 400;
    color: #212529;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
}

.mr-2{
    margin-right: 0.5rem!important;
}

.float-right {
    float: right!important;
}


.download-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px;
}

/* Style for individual download buttons */
.download-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    margin: 0 10px;
    font-size: 18px;
    border: 2px solid #007bff; /* Blue border color */
    border-radius: 5px;
    background-color: #007bff; /* Blue background color */
    color: #fff; /* White text color */
    text-decoration: none;
    transition: background-color 0.3s ease, color 0.3s ease, border 0.3s ease;
}

/* Hover effect */
.download-button:hover {
    background-color: transparent; /* Transparent background on hover */
    color: #007bff; /* Blue text color on hover */
}

/* Google Play button */
.google-play {
    border-color: #0f9d58; /* Green border color for Google Play */
    background-color: #0f9d58; /* Green background color for Google Play */
}

/* App Store button */
.app-store {
    border-color: #ff9500; /* Orange border color for App Store */
    background-color: #ff9500; /* Orange background color for App Store */
}
.download {
    border-radius: 5px 50px 50px 5px;
    width: -moz-fit-content;
    width: fit-content;
  }
  /* Media query to remove border radius on mobile */
  @media (max-width: 570px) {
    .download {
      border-radius: 5px 50px 50px 5px; 
      width: -moz-fit-content; 
      width: fit-content;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/footer/footer.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;AACvC;;;AAGA;;AAEA;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,iBAAiB;AACrB;;;AAGA;IACI,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,wBAAwB;IACxB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;AACpB;;;IAGI,aAAa,kBAAkB,EAAE,oBAAoB,EAAE,sBAAsB,CAAC;IAC9E,QAAQ,WAAW,CAAC;;;IAGpB,eAAe,yBAAyB,EAAE,WAAW,CAAC;IACtD,qBAAqB,WAAW,CAAC;;IAEjC,gBAAgB,yBAAyB,CAAC,WAAW,CAAC;IACtD,sBAAsB,WAAW,CAAC;;IAElC,cAAc,yBAAyB,EAAE,WAAW,CAAC;IACrD,oBAAoB,WAAW,CAAC;;IAEhC,cAAc,yBAAyB,EAAE,WAAW,CAAC;IACrD,oBAAoB,WAAW,CAAC;;;;AAIpC;IACI,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,oEAAoE;AACxE;;AAEA;IACI,2BAA2B;IAC3B,mEAAmE;AACvE;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,kBAAkB;IAClB,6BAAoB;IAApB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,kBAAkB;IAClB,6BAAoB;IAApB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,0BAA0B;IAC1B,wBAAwB;IACxB,wBAAwB;IACxB,sBAAsB;;AAE1B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,6BAA6B;IAC7B,2BAA2B;IAC3B,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,sBAAsB;AAC1B;;;;;;;;;;;;AAYA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,mCAAmC;IACnC,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;;AAE5C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;IACtC,oCAAoC;IACpC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,yBAAyB,EAAE,sBAAsB;IACjD,kBAAkB;IAClB,yBAAyB,EAAE,0BAA0B;IACrD,WAAW,EAAE,qBAAqB;IAClC,qBAAqB;IACrB,yEAAyE;AAC7E;;AAEA,iBAAiB;AACjB;IACI,6BAA6B,EAAE,oCAAoC;IACnE,cAAc,EAAE,6BAA6B;AACjD;;AAEA,uBAAuB;AACvB;IACI,qBAAqB,EAAE,uCAAuC;IAC9D,yBAAyB,EAAE,2CAA2C;AAC1E;;AAEA,qBAAqB;AACrB;IACI,qBAAqB,EAAE,sCAAsC;IAC7D,yBAAyB,EAAE,0CAA0C;AACzE;AACA;IACI,gCAAgC;IAChC,uBAAkB;IAAlB,kBAAkB;EACpB;EACA,kDAAkD;EAClD;IACE;MACE,gCAAgC;MAChC,uBAAkB;MAAlB,kBAAkB;IACpB;EACF","sourcesContent":[".section-footer{\r\n    background-color: #f1f3f7!important;\r\n}\r\n\r\n\r\n.footer-top {\r\n\r\n}\r\n\r\n.container{\r\n    width: 100%;\r\n    padding-right: 15px;\r\n    padding-left: 15px;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n}\r\n\r\nsection {\r\n    display: block;\r\n}\r\n\r\nfooter {\r\n    display: block;\r\n}\r\n\r\n\r\n.padding-top {\r\n    padding-top: 32px;\r\n}\r\n\r\n\r\n.border-top-gray {\r\n    border-top: 1px solid #e0e0e0!important;\r\n}\r\n\r\na {\r\n    color: #777;\r\n    text-decoration: none;\r\n    font-size: 0.805rem;\r\n    font-weight: 400;\r\n    line-height: 1.5;\r\n    transition: all .25s ease;\r\n    background-color: transparent;\r\n}\r\n\r\na:-webkit-any-link {\r\n    cursor: pointer;\r\n}\r\na:hover {\r\n    color: #b16927;\r\n}\r\n\r\nh5 {\r\n    display: block;\r\n    font-size: 1.00625rem;\r\n    margin-inline-start: 0px;\r\n    margin-inline-end: 0px;\r\n    font-family: inherit;\r\n    margin-bottom: 0.5rem;\r\n    line-height: 1.2;\r\n}\r\n\r\n\r\n    .btn-group { position: relative; display: inline-flex; vertical-align: middle;}\r\n    .white {color: #fff;}\r\n\r\n\r\n    .btn-facebook {background-color: #405D9D; color: #fff;}\r\n    .btn-facebook:hover {color: #fff;}\r\n\r\n    .btn-instagram {background-color: #E52D27;color: #fff;}\r\n    .btn-instagram:hover {color: #fff;}\r\n\r\n    .btn-youtube {background-color: #C8046C; color: #fff;}\r\n    .btn-youtube:hover {color: #fff;}\r\n\r\n    .btn-twitter {background-color: #42AEEC; color: #fff;}\r\n    .btn-twitter:hover {color: #fff;}\r\n\r\n\r\n\r\n.btn {\r\n    font-size: .875rem;\r\n    transition: all .2s ease;\r\n    letter-spacing: .025em;\r\n    text-transform: uppercase;\r\n    font-weight: 600;\r\n    line-height: 1.5;\r\n    padding: 0.625rem 1.25rem;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    white-space: nowrap;\r\n    border-radius: 50px;\r\n    box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);\r\n}\r\n\r\n.btn:hover {\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08);\r\n}\r\n\r\n.fab{\r\n    -webkit-font-smoothing: antialiased;\r\n    display: inline-block;\r\n    font-style: normal;\r\n    font-variant: normal;\r\n    text-rendering: auto;\r\n    line-height: 1;\r\n    font-weight: 400;\r\n    font-family: Font Awesome\\ 5 Brands;\r\n}\r\n\r\n.fa-fw {\r\n    text-align: center;\r\n    width: 1.2em;\r\n}\r\n\r\n.fas{\r\n    -webkit-font-smoothing: antialiased;\r\n    display: inline-block;\r\n    font-style: normal;\r\n    font-variant: normal;\r\n    text-rendering: auto;\r\n    line-height: 1;\r\n    font-family: Font Awesome\\ 5 Free;\r\n    font-weight: 900;\r\n    font-size: 1.00625rem;\r\n    color: inherit;\r\n    margin-right: 0.3125rem;\r\n}\r\n\r\n.title{\r\n    font-weight: 600;\r\n}\r\n\r\n.display-inline-block{\r\n    display: inline-block!important;\r\n}\r\n\r\n.mt-4{\r\n    margin-top: 1.5rem!important; \r\n}\r\n\r\n.h5Lang{\r\n    font-size: 1.00625rem;\r\n    margin-bottom: 0.5rem;\r\n    font-family: inherit;\r\n    line-height: 1.2;\r\n    color: inherit;\r\n    margin-block-start: 1.67em;\r\n    margin-block-end: 1.67em;\r\n    margin-inline-start: 0px;\r\n    margin-inline-end: 0px;\r\n\r\n}\r\n\r\n.clearfix{\r\n    content: \"\";\r\n    clear: both;\r\n    display: table; \r\n}\r\n\r\n.footer-bottom{\r\n    padding: 15px 0;\r\n}\r\n\r\n.row{\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin-right: -15px;\r\n    margin-left: -15px;\r\n}\r\n\r\n.col-sm-12{\r\n    position: relative;\r\n    width: 100%;\r\n    padding-right: 15px;\r\n    padding-left: 15px;\r\n}\r\n\r\n\r\np {\r\n    margin-top: 0;\r\n    /* margin-bottom: 1rem; */\r\n    display: block;\r\n    /* margin-block-start: 1em; */\r\n    /* margin-block-end: 1em; */\r\n    margin-inline-start: 0px;\r\n    margin-inline-end: 0px;\r\n}\r\n\r\n.text-center{\r\n    text-align: center!important;\r\n}\r\n\r\n.text-dark{\r\n    color: #343a40!important;\r\n}\r\n\r\n.text-gray {\r\n    color: #f1f3f7!important;\r\n    margin-left: 3px;\r\n    margin-right: 3px;\r\n}\r\n\r\n.text-dark-50 {\r\n    font-size: .805rem;\r\n\r\n}\r\n\r\nstrong {\r\n    font-weight: bolder;\r\n}\r\n* {\r\n    box-sizing: border-box;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.dropdown {\r\n    position: relative;\r\n}\r\n\r\n.ml-5 {\r\n    margin-left: 2.5rem!important;\r\n}\r\n\r\n.display-inline-block {\r\n    display: inline-block!important;\r\n}\r\n\r\n.fa-caret-down::before {\r\n    content: \"\\f0d7\"; \r\n}\r\n::before {\r\n    box-sizing: border-box;\r\n}\r\n\r\n.flag {\r\n    width: 1.46667rem;\r\n    height: 1.15rem;\r\n    display: inline-block;\r\n    background: no-repeat 50%/100% 100%;\r\n    vertical-align: bottom;\r\n    font-style: normal;\r\n    box-shadow: 0 0 1px 1px rgb(0 0 0 / 10%);\r\n    \r\n}\r\n\r\n.ml-2 {\r\n    margin-left: 0.5rem!important;\r\n}\r\n\r\n.dropdown-menu.show {\r\n    box-shadow: 0 3px 8px rgb(0 0 0 / 15%);\r\n    border: 1px solid rgba(0,40,100,.12);\r\n    border-radius: 0;\r\n    display: block;\r\n}\r\n\r\n.dropdown-menu[x-placement^=top] {\r\n    right: auto;\r\n    bottom: auto;\r\n}\r\n\r\n.dropdown-menu {\r\n    z-index: 1000;\r\n    float: left;\r\n    min-width: 10rem;\r\n    padding: 0.5rem 0;\r\n    margin: 0.125rem 0 0;\r\n    font-size: .805rem;\r\n    color: #212529;\r\n    text-align: left;\r\n    list-style: none;\r\n    background-color: #fff;\r\n    background-clip: padding-box;\r\n}\r\n\r\n.dropdown-item {\r\n    padding: 0.5rem 1.5rem;\r\n    margin: 5px 0;\r\n    display: block;\r\n    width: 100%;\r\n    clear: both;\r\n    font-weight: 400;\r\n    color: #212529;\r\n    text-align: inherit;\r\n    white-space: nowrap;\r\n    background-color: transparent;\r\n    border: 0;\r\n}\r\n\r\n.mr-2{\r\n    margin-right: 0.5rem!important;\r\n}\r\n\r\n.float-right {\r\n    float: right!important;\r\n}\r\n\r\n\r\n.download-buttons {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: 20px;\r\n}\r\n\r\n/* Style for individual download buttons */\r\n.download-button {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 10px 20px;\r\n    margin: 0 10px;\r\n    font-size: 18px;\r\n    border: 2px solid #007bff; /* Blue border color */\r\n    border-radius: 5px;\r\n    background-color: #007bff; /* Blue background color */\r\n    color: #fff; /* White text color */\r\n    text-decoration: none;\r\n    transition: background-color 0.3s ease, color 0.3s ease, border 0.3s ease;\r\n}\r\n\r\n/* Hover effect */\r\n.download-button:hover {\r\n    background-color: transparent; /* Transparent background on hover */\r\n    color: #007bff; /* Blue text color on hover */\r\n}\r\n\r\n/* Google Play button */\r\n.google-play {\r\n    border-color: #0f9d58; /* Green border color for Google Play */\r\n    background-color: #0f9d58; /* Green background color for Google Play */\r\n}\r\n\r\n/* App Store button */\r\n.app-store {\r\n    border-color: #ff9500; /* Orange border color for App Store */\r\n    background-color: #ff9500; /* Orange background color for App Store */\r\n}\r\n.download {\r\n    border-radius: 5px 50px 50px 5px;\r\n    width: fit-content;\r\n  }\r\n  /* Media query to remove border radius on mobile */\r\n  @media (max-width: 570px) {\r\n    .download {\r\n      border-radius: 5px 50px 50px 5px; \r\n      width: fit-content;\r\n    }\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
